import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://kusrc.co.kr";
const SITE_NAME = "케이유융합소프트웨어연구센터";
const DEFAULT_IMAGE = `${SITE}/img/og-image.jpg`;

type SeoProps = {
    title: string;
    description: string;
    path: string;
    image?: string;
};

const Seo = ({ title, description, path, image = DEFAULT_IMAGE }: SeoProps) => {
    const fullTitle = `${title} | ${SITE_NAME}`;
    const url = `${SITE}${path}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="KUSRC" />
            <meta property="og:locale" content="ko_KR" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};

export default Seo;
